import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable react/sort-comp,react/jsx-handler-names */
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as ObjectUtil from 'helpers/object';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { AccountCard } from './AccountCard';
import { LeadCard } from './LeadCard';
import { ProductCard } from './ProductCard';
import { ProductForm } from '../forms/ProductForm';
import { redirectToNextStep, watchSignupCardSagas } from '../sagas/signup-card.saga';
var STEPS = {
  ACCOUNT: 'account',
  LEAD: 'lead',
  PRODUCT: 'product'
};
export var TRANSITION_DELAY = 600;
export var SignupCardUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(SignupCardUnwrapped, _Component);

  function SignupCardUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SignupCardUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SignupCardUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.advanceStep = _this.advanceStep.bind(_assertThisInitialized(_this));
    _this.clearPreviousStep = _this.clearPreviousStep.bind(_assertThisInitialized(_this));
    _this.onComplete = _this.onComplete.bind(_assertThisInitialized(_this));
    _this.renderStepAccount = _this.renderStepAccount.bind(_assertThisInitialized(_this));
    _this.renderStepLead = _this.renderStepLead.bind(_assertThisInitialized(_this));
    _this.renderStepProduct = _this.renderStepProduct.bind(_assertThisInitialized(_this));
    _this.state = {
      steps: [STEPS.PRODUCT, STEPS.LEAD, STEPS.ACCOUNT],
      previousStep: null
    };
    return _this;
  }

  _createClass(SignupCardUnwrapped, [{
    key: "advanceStep",
    value: function advanceStep(results) {
      var _this$state = this.state,
          steps = _this$state.steps,
          stepResults = _this$state.stepResults;

      var _steps = _toArray(steps),
          currentStep = _steps[0],
          nextSteps = _steps.slice(1);

      this.setState({
        stepResults: _objectSpread({}, stepResults, results)
      });

      if (isEmpty(nextSteps)) {
        this.onComplete();
      } else {
        this.setState({
          steps: nextSteps,
          previousStep: currentStep
        });
      }
    }
  }, {
    key: "clearPreviousStep",
    value: function clearPreviousStep() {
      this.setState({
        previousStep: null
      });
    }
  }, {
    key: "hasPreviousStep",
    value: function hasPreviousStep() {
      return Boolean(this.state.previousStep);
    }
  }, {
    key: "isCurrentStep",
    value: function isCurrentStep(step) {
      return this.state.steps[0] === step;
    }
  }, {
    key: "isPreviousStep",
    value: function isPreviousStep(step) {
      return this.state.previousStep === step;
    }
  }, {
    key: "onComplete",
    value: function onComplete() {
      if (this.props.onComplete) {
        this.props.onComplete(this.props.url);
      }
    }
  }, {
    key: "renderStep",
    value: function renderStep(stepName, stepRenderer) {
      if (this.isPreviousStep(stepName)) {
        setTimeout(this.clearPreviousStep, TRANSITION_DELAY);
        return React.createElement("div", {
          className: "anim anim--fadeOut"
        }, stepRenderer());
      } else if (this.isCurrentStep(stepName) && !this.hasPreviousStep()) {
        return React.createElement("div", {
          className: "anim anim--fadeIn"
        }, stepRenderer());
      }
    }
  }, {
    key: "renderStepAccount",
    value: function renderStepAccount() {
      return React.createElement(AccountCard, {
        hiddenFields: this.state.stepResults,
        onSuccess: this.advanceStep,
        tag: this.props.tag
      });
    }
  }, {
    key: "renderStepLead",
    value: function renderStepLead() {
      return React.createElement(LeadCard, {
        hiddenFields: _objectSpread({}, this.state.stepResults, {
          resumeSignupLink: this.props.url
        }),
        onLeadSuccess: this.advanceStep,
        onFacebookSuccess: this.onComplete,
        tag: this.props.tag
      });
    }
  }, {
    key: "renderStepProduct",
    value: function renderStepProduct() {
      var _this$props = this.props,
          ctaCopy = _this$props.ctaCopy,
          productId = _this$props.productId,
          productType = _this$props.productType;
      var productCardProps = ObjectUtil.pick(Object.keys(ProductCard.propTypes), this.props);
      var cta = React.createElement(ProductForm, {
        copy: ctaCopy,
        hiddenFields: _objectSpread({}, this.state.stepResults, {
          productId: productId,
          productType: productType,
          resumeSignupLink: this.props.url
        }),
        onSuccess: this.advanceStep
      });
      return React.createElement(ProductCard, _extends({}, productCardProps, {
        cta: cta
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Fragment, null, this.renderStep(STEPS.ACCOUNT, this.renderStepAccount), this.renderStep(STEPS.LEAD, this.renderStepLead), this.renderStep(STEPS.PRODUCT, this.renderStepProduct));
    }
  }]);

  return SignupCardUnwrapped;
}(Component);
SignupCardUnwrapped.propTypes = _objectSpread({}, ProductCard.propTypes, {
  productId: PropTypes.number,
  productType: PropTypes.string
});
export var SignupCard = decorateWith(withSagas({
  watch: watchSignupCardSagas
}), connect(null, {
  onComplete: redirectToNextStep
}), withName('SignupCard'))(SignupCardUnwrapped);